import {
    GoogleOptimize,
    GoogleOptimizeExperiment,
} from '@/common/models/ab-testing';
import {
    BBAddon,
    BBInfoItem,
    InfrastructureOwner,
    Technology,
    TechnologyType,
} from '@/common/models/sows';
import { STANDARD_PRICES } from '@/common/utilities/settings';

/**
 * Mock product is a method to output products that resemble what might come from the SOWS API.
 *
 * @param speed
 * @param technology_type
 * @param initial_fee
 * @param recurrent
 * @param shipment
 * @param infrastructureOwner
 * @param addons
 * @returns {{action_url: string, technology_type: TechnologyType, addons: {products: Array}, technology: TechnologyType, up_speed: number, label: string, offer_code: string, order_code: string, down_speed: number, total: {initial: number, recurrent: number}, price: {initial: number, recurrent: number}, name: string, bid: string, lines: {fees: *[], products: Array, hardware: Array}}}
 */
export function mockBBProduct(
    speed: number = 200,
    technology_type: TechnologyType = 'coax',
    initial_fee: number = STANDARD_PRICES.initial_fee,
    recurrent: number = STANDARD_PRICES.recurrent,
    shipment: number = STANDARD_PRICES.shipment,
    infrastructureOwner: InfrastructureOwner = 'stofa',
    addons: BBAddon[] = []
): BBInfoItem {
    return {
        bid: 'NAT0022',
        name: speed === 1000 ? 'Giga' : 'Stofa Internet', // BroadbandPackage uses name of giga to handle shadow products
        infrastructure_owner: infrastructureOwner,
        technology: technology_type as Technology,
        technology_type: technology_type,
        down_speed: speed,
        up_speed: speed,
        label: 'Mbit',
        order_code: 'NAT0022',
        price: {
            initial: 0,
            recurrent: recurrent,
        },
        action_url: '',
        offer_code: '',
        lines: {
            products: [],
            hardware: [],
            fees: [
                {
                    name: 'Oprettelsesgebyr',
                    description: '',
                    price: {
                        initial: initial_fee,
                        recurrent: null,
                    },
                },
                {
                    name: 'Forsendelse',
                    description: '',
                    price: {
                        initial: shipment,
                        recurrent: null,
                    },
                },
            ],
        },
        addons: {
            addons,
            products: [],
            fees: [],
            hardware: [],
        },
        total: {
            initial: 0,
            recurrent: recurrent,
        },
    };
}

export class MockedGoogleOptimizeInstance implements GoogleOptimize {
    public active_experiments: GoogleOptimizeExperiment[];

    constructor(active_experiments: GoogleOptimizeExperiment[]) {
        this.active_experiments = active_experiments;
    }

    get(id: string) {
        const matching_experiment = this.active_experiments.find(
            (experiment) => experiment.id === id
        );

        if (matching_experiment) {
            return matching_experiment.active_variant;
        } else {
            return undefined;
        }
    }
}
